import { constants, mediaQueryStyles } from "@newsela/angelou";

import { overviewFontBuilderCss } from "@/reports/teacher/common/OverviewDataResults/OverviewDataResults.style";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { BreakpointNames } = constants.breakpoints;
const { ui } = constants.colors;

const coreBlue500 = ui.core[500];

export const gradeLevelChartRowCss = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "16px",

  p: {
    margin: "0",
  },
};

export const gradeLevelLabelCss = {
  width: "10rem",
  margin: "0",
  textAlign: "end" as const,
  ...overviewFontBuilderCss({
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "150%",
  }),
};

export const gradeLevelChartCss = (
  value: number,
  maxValue: number,
  labelIsDoubleLine: boolean,
) => {
  const percentage = value ? (value / maxValue) * 80 : 2;
  return {
    height: labelIsDoubleLine ? "40px" : "25px",
    width: `${percentage}%`,
    backgroundColor: coreBlue500,
    borderRadius: "0 8px 0 0",
  };
};

export const gradeLevelChartLoadingStateCss = (labelIsDoubleLine: boolean) => {
  return {
    height: labelIsDoubleLine ? "40px" : "25px",
    width: "40%",
    borderRadius: "0 8px 0 0",
  };
};

export const chartContainerCss = {
  width: "40%",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  [breakpoint.between("1024px", "1300px")]: {
    width: "50%",
  },
  [breakpoint.between("568px", BreakpointNames.sm)]: {
    width: "70%",
  },

  p: {
    color: "#04337A",
    ...overviewFontBuilderCss({
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "120%",
    }),
  },
};
